export enum ITabId {
    GENERAL = "General",
    SALES = "Sales Screen",
    PURCHASE = "Purchase Detail",
}
